@if (isLoaded && attachments) {
  <rt-requisitions-files-container [requisitionId]="requisitionId" [attachments]="attachments" />
} @else {
  <rt-spinner />
}
